"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageCode = void 0;
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["English"] = "en";
    LanguageCode["French"] = "fr";
    LanguageCode["German"] = "de";
    LanguageCode["Spanish"] = "es";
    LanguageCode["Arabic"] = "ar";
    LanguageCode["Dutch"] = "nl";
    LanguageCode["Albanian"] = "sq";
    LanguageCode["Azeri"] = "az";
    LanguageCode["Bengali"] = "bn";
    LanguageCode["Bulgarian"] = "bg";
    LanguageCode["Croatian"] = "hr";
    LanguageCode["Czech"] = "cs";
    LanguageCode["Danish"] = "da";
    LanguageCode["Estonian"] = "et";
    LanguageCode["Farsi"] = "fa";
    LanguageCode["Finnish"] = "fi";
    LanguageCode["Greek"] = "el";
    LanguageCode["Hausa"] = "ha";
    LanguageCode["Hebrew"] = "he";
    LanguageCode["Hindi"] = "hi";
    LanguageCode["Hungarian"] = "hu";
    LanguageCode["Icelandic"] = "is";
    LanguageCode["Indonesian"] = "id";
    LanguageCode["Italian"] = "it";
    LanguageCode["Japanese"] = "ja";
    LanguageCode["Kazakh"] = "kk";
    LanguageCode["Korean"] = "ko";
    LanguageCode["Kyrgyz"] = "ky";
    LanguageCode["Latin"] = "la";
    LanguageCode["Latvian"] = "lv";
    LanguageCode["Lithuanian"] = "lt";
    LanguageCode["Macedonian"] = "mk";
    LanguageCode["Mongolian"] = "mn";
    LanguageCode["Nepali"] = "ne";
    LanguageCode["Norwegian"] = "no";
    LanguageCode["Pashto"] = "ps";
    LanguageCode["Polish"] = "pl";
    LanguageCode["Portuguese"] = "pt";
    LanguageCode["Romanian"] = "ro";
    LanguageCode["Russian"] = "ru";
    LanguageCode["Serbian"] = "sr";
    LanguageCode["Slovak"] = "sk";
    LanguageCode["Slovene"] = "sl";
    LanguageCode["Somali"] = "so";
    LanguageCode["Swahili"] = "sw";
    LanguageCode["Swedish"] = "sv";
    LanguageCode["Tagalog"] = "tl";
    LanguageCode["Thai"] = "th";
    LanguageCode["Turkish"] = "tr";
    LanguageCode["Ukrainian"] = "uk";
    LanguageCode["Urdu"] = "ur";
    LanguageCode["Uzbek"] = "uz";
    LanguageCode["Vietnamese"] = "vi";
    LanguageCode["Welsh"] = "cy";
})(LanguageCode = exports.LanguageCode || (exports.LanguageCode = {}));
//# sourceMappingURL=languageCode.enum.js.map